import { apiGet, apiPostGet } from '@/services/api.ts';
import { TLabelValue } from '@/types/misc.ts';
import { config } from '@/config';
import { IProductsRes, TAdminProduct, TListProduct } from '@/types/models.ts';

export async function getProducts(params: any) {
  return await apiGet<IProductsRes>('products', params);
}

export async function getAdminProduct(id: number, colorId?: number) {
  const params = colorId ? { color_id: colorId } : {};
  return await apiGet<TAdminProduct>(`admin/products/${id}`, params);
}

export type TSuccessRes = {
  success: boolean;
  message?: string;
};

export async function saveAdminProduct(data: any) {
  return await apiPostGet<TSuccessRes>(`admin/products`, data);
}

export async function adminProductReindex(id: number) {
  return await apiPostGet<TSuccessRes>(`admin/products/${id}/reindex`);
}

export function getAdminProductUrl(productId: number, colorId?: number) {
  return colorId
    ? config.getAdminUrl(`/admin/productColours/${colorId}`)
    : config.getAdminUrl(`/admin/products/${productId}`);
}

export async function getAdminProductVisibilityOpts() {
  return await apiGet<TLabelValue[]>(`admin/products/visibility-opts`);
}

export async function getAdminProductAvailabilityOpts() {
  return await apiGet<TLabelValue[]>(`admin/products/availability-opts`);
}

export async function getAdminProductColorOpts() {
  return await apiGet<TLabelValue[]>(`admin/products/color-opts`);
}

export async function getAdminProductConstructionOpts() {
  return await apiGet<TLabelValue[]>(`admin/products/construction-opts`);
}

export async function getAdminProductPatternOpts() {
  return await apiGet<TLabelValue[]>(`admin/products/pattern-opts`);
}

export type TProjectSearchItem = {
  id: number;
  name: string;
  has_product: boolean;
};

export async function getProjectSearch(params: any) {
  return await apiGet<TProjectSearchItem[]>(`projects/search`, params);
}

export async function createProject(data: any) {
  return await apiPostGet<TSuccessRes>(`projects`, data);
}

export async function addToProject(data: any) {
  return await apiPostGet<TSuccessRes>(`projects/add-product`, data);
}

export async function removeFromProject(data: any) {
  return await apiPostGet<TSuccessRes>(`projects/remove-product`, data);
}

export async function getProduct(productId: number, colorId?: number) {
  const params = colorId ? { color_id: colorId } : {};
  return await apiGet<TListProduct>(`products/${productId}`, params);
}

export async function getCuttingRequest(colorId: number) {
  return await apiGet<TSuccessRes>(`products/cutting-request/${colorId}`);
}

export async function sendCuttingRequest(colorId: number) {
  return await apiPostGet<TSuccessRes>(`products/cutting-request/${colorId}`);
}